<template>
  <div class="box">
    <!-- banner -->
    <Banner :banner-h="$t('entranceGuard.bannerTitle')" :banner-title-style="bannerTitleSytle" :text-style="textStyle"
            :banner-p="$t('entranceGuard.bannerDescription')" :banner-img="bannerImg1"></Banner>
    <scroll-animate>

    <div class="productCatg core_box">
      <!-- <h1>产品类别</h1>-->

      <div class="catgDetails" v-for="(item,index) in catgDetails" :key="index">
        <h2>{{ item.categoryName }}</h2>
          <div class="catgItem" v-for="(item,index) in item.catgItem" :key="index" @click="ruterClick(item)">
            <div class="catgImg">
              <img :src="item.catgImg"/>
            </div>
            <div class="catgItemText">
              <span>{{ item.name }}</span>
              <p>{{ item.text }}</p>
            </div>
          </div>
      </div>
    </div>
    </scroll-animate>
  </div>
</template>
<script>
import Banner from "@/components/banner.vue";
import {entranceGuard} from "@/assets/js/entranceGuard.js";
import productSeoMixin from '@/mixins/productSeoMixin';
import i18n from '@/plugins/i18n';
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  name: "entranceGuard",
  components: {
    ScrollAnimate,
    Banner,
  },
  mixins: [productSeoMixin],
  created() {
    this.catgDetails = entranceGuard
  },
  data() {
    return {
      bannerImg1: require("@/assets/img/banner-bg/bananer-mountain.png"),
      textStyle: {
        width: "65%",
      },
      bannerTitleSytle: {
        fontSize: "2rem",
      },
      catgDetails: []
    };
  },

  methods: {
    ruterClick(item) {
      this.$router.push({
        name: 'productInfoShow',
        query: {
          item: item.id
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/product-pub.scss";
</style>
